import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgke341aRequest, Sgke341aResponse, Sgke342aRequest, Sgke902aRequest } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { UsedSgke902aService } from '../../../../../sg-ke-shared/services/used-sgke902a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { Sgke370dDialogComponent } from '../../../sgke370d/components/sgke370d-dialog/sgke370d-dialog.component';
import { Sgke370dDialogData } from '../../../sgke370d/models/sgke370d-dialog-data';
import { UsedSgke341aService } from '../../services/used-sgke341a.service';
import { UsedSgke342aService } from '../../services/used-sgke342a.service';
import { UsedSgke343aService } from '../../services/used-sgke343a.service';

@Component({
  selector: 'app-sgke340d',
  templateUrl: './sgke340d.component.html',
  styleUrl: './sgke340d.component.scss'
})
export class Sgke340dComponent implements OnInit, OnDestroy {

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 供給停止再開作業場所コード_現地作業 */
  private static WORK_PLACE_CODE_LOCAL = '1';
  /** 供給停止再開作業場所コード_遠隔 */
  private static WORK_PLACE_CODE_REMOTE = '2';

  /** メーター分類コード_マイコンメーター */
  private static METER_BUNRUI_CODE_MCU = '02';

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** 供給地点特定番号 */
  suppntSpno: string = null;
  /** 供給停止再開履歴番号 */
  supplystopresumptionRrkno: string = null;

  /** 全体リクエストフォームグループ */
  requestFormGroup: UntypedFormGroup;
  /** コード変換マスタマップ */
  codeMap: Map<string, CodeConversionMstDto[]> = null;
  /** 初期化APIの返り値 */
  initResponse: Sgke341aResponse = null;
  /** MatDialog戻り値 */
  ref: MatDialogRef<Sgke370dDialogComponent, any>;
  /** エラーメッセージ表示制御 */
  isErrorMessageDisplay: boolean = true;

  /**
   * コンストラクタ
   * @param {ActivatedRoute} route
   * @param {UntypedFormBuilder} fb
   * @param {CodeConversionMstService} codeConvert
   * @param {UsedSgke341aService} initService
   * @param {UsedSgke342aService} registrationService
   * @param {UsedSgke902aService} rescheduleService
   * @param {TimeApiService} timeApiService
   * @param {MatDialog} dialog
   * @param {Router} router
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke340dComponent
   */
  constructor(
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private codeConvert: CodeConversionMstService,
    public initService: UsedSgke341aService,
    private registrationService: UsedSgke342aService,
    private pauseService: UsedSgke343aService,
    private rescheduleService: UsedSgke902aService,
    private timeApiService: TimeApiService,
    private dialog: MatDialog,
    private router: Router,
    private responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) {
    // 画面遷移元パラメータ取得
    this.suppntSpno = this.route.snapshot.paramMap.get('suppntSpno');
    this.supplystopresumptionRrkno = this.route.snapshot.paramMap.get('supplystopresumptionRrkno');
  }

  /**
   * 初期処理
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  ngOnInit(): void {

    // リクエストフォームグループ初期化
    this.requestFormGroup = this.fb.group({
      requestCommon: {},
    });

    // コード変換マスタ取得
    const dispItemIdList = [
      'S300801',
      'S300771',
      'S300810',
      'S300820',
      'S301191',
      'S301231',
    ];
    //コード変換マスタ共通コンポーネント呼び出し
    this.codeConvert.getCodeConversionMst(dispItemIdList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(codeMap => {
        // ローカルに保存
        this.codeMap = codeMap;
      });

    this.init();
  }

  /**
   * 購読解除
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 指針入力ボタン押下時処理
   * @public
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  public onClickShishinBtn(): void {

    const suppntInfo = this.initResponse.initialhyojiInfo.basicInfoArea.suppntInfo;
    const shishinInputCont = this.initResponse.initialhyojiInfo.regInfoArea.shishinInputCont;

    const data: Sgke370dDialogData = {
      // 供給地点特定番号
      suppntSpno: this.getControl('suppntSpno').value,
      // 供給停止再開履歴番号
      supplystopresumptionRrkno: this.getControl('supplystopresumptionRrkno').value,
      // 供給停止・再開作業種別コード
      supplystopresumptionWorkClscode: suppntInfo.workClscode,
      // エネルギー種別コード
      energyClscode: suppntInfo.energyClscode,
      // 供給停止・供給再開作業日付
      supplystopYearmonthdate: this.getControl('supplystopDate').value == null ? null : this.timeApiService.convertDateToString(this.getControl('supplystopDate').value),
      // 検針タイミング
      kenshinTiming: this.getControl('preKenshinTiming').value,
      // 前回メーター番号
      preMeterNo: this.getControl('preOnkenshinMeternumber').value,
      // 前回指針値
      preShishin: shishinInputCont.preKenshinvalue,
      // 前回メータ型
      preMeterModel: shishinInputCont.preMeterModel,
      // 前回メータ能力
      preMeterAbility: shishinInputCont.preMeterAbility,
      // 前回メータ情報一致フラグ
      meterInfoIcchiflag: this.getControl('meterInfoIcchiflag').value,
      // メータ取替有フラグ
      meterTorikaeEonflg: this.getControl('meterTorikaeEonflg').value,
      // 取外メータ番号
      removalMeterNo: this.getControl('removalMeterNo').value,
      // 取外時指針
      duringremovalShishin: this.getControl('duringremovalShishin').value,
      // 取付メータ番号
      installationMeterNo: this.getControl('installationMeterNo').value,
      // 取付時指針
      duringinstallationShishin: this.getControl('duringinstallationShishin').value,
      // メーター回転有無フラグ
      meterRotationEonflg: this.getControl('meterRotationEonflg').value,
      // 今回指針値
      duringstopShishin: this.getControl('duringstopShishin').value,
    };

    // エラーメッセージを非表示に切替
    this.onModalIsDisplay(false);

    // ダイアログオープン
    this.ref = this.dialog.open(Sgke370dDialogComponent, {
      height: '950px',
      width: '1000px',
      disableClose: true,
      data: data,
    });

    // クローズ時の処理
    this.ref.afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(result => {
        const propMap = {
          meterInfoIcchiflag: 'meterInfoIcchiflag',
          meterTorikaeEonflg: 'meterTorikaeEonflg',
          removalMeterNo: 'removalMeterNo',
          duringremovalShishin: 'duringremovalShishin',
          installationMeterNo: 'installationMeterNo',
          duringinstallationShishin: 'duringinstallationShishin',
          meterRotationEonflg: 'meterRotationEonflg',
          duringstopShishin: 'duringstopShishin',
          elecCsp: 'duringstopEmpamt',
          resultregistrationFinDisableflag: 'shishinInputErrorflag',
        };
        Object.entries(result).forEach(([key, val]) => {
          const value = val === '' ? null : val;
          this.getControl(propMap[key])?.setValue(value);
          // 取付メータ番号が入力されていた場合は停止時メーター番号を置き換え
          if (key == 'installationMeterNo' && val) {
            this.getControl('duringstopMeterNo')?.setValue(val);
          }
        });

        // エラーメッセージを表示に切替
        this.onModalIsDisplay(true);
      });
  }

  /**
   * コントロール取得
   * @public
   * @param {string} ctrlName
   * @returns {UntypedFormControl}
   * @memberof Sgke340dComponent
   */
  public getControl(ctrlName: string): UntypedFormControl {
    return this.requestFormGroup.get('supplystopResultInfo').get(ctrlName) as UntypedFormControl;
  }

  /**
   * ボタン押下時処理
   * @public
   * @param {string} button ボタン名
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  public onClickButton(button: string): void {

    // メッセージクリア
    this.clearErrorMsg();

    if (button == 'register') {
      // 登録ボタン押下の場合
      // 作業結果取得
      const supplystopResultDivcd = this.getControl('supplystopResultDivcd').value;

      if (supplystopResultDivcd == '0') {
        // 作業結果が供給停止の場合
        if (this.checkCorrelation()) {
          // 相関チェックに該当した場合
          // OKを押下した場合、SGKE342AのAPIを呼び出す
          // キャンセルの場合、供給停止結果登録画面に戻る

          if (!window.confirm('封印措置／ロック措置が未実施です。登録してよろしいですか？')) {
            return;
          }
        }
        this.register(button);

      } else if (supplystopResultDivcd == '1') {
        // 作業結果が延期の場合
        this.reschedule();
      }

    } else if (button == 'cancel') {
      // 中断ボタン押下の場合
      this.register(button);

    } else if (button == 'payNotify') {
      // 入金連絡受付ボタン押下の場合
      // 受付基盤に画面遷移
      this.navigateToReceptionPlatform('13');
    } else if (button == 'customerInquiry') {
      // お客さま照会ボタン押下の場合
      // 受付基盤に画面遷移
      this.navigateToReceptionPlatform('12');
    }
  }

  /**
   * 初期表示API呼び出し
   * @private
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  private init(): void {
    // メッセージクリア
    this.clearErrorMsg();

    // Formの内容をリクエストに設定
    let request: Sgke341aRequest = {
      requestCommon: null,
      initialhyojiCndt: {
        suppntSpno: this.suppntSpno,
        supplystopresumptionRrkno: this.supplystopresumptionRrkno,
      },

    };

    //SGKE341A_供給停止結果登録初期表示API呼び出し
    this.initService.doSgke341a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {
            // 停止時メーター番号が設定されていない場合は前回メーター番号をセットしておく
            if (response.initialhyojiInfo.regInfoArea.shishinInputCont.duringstopMeterNo == null) {
              response.initialhyojiInfo.regInfoArea.shishinInputCont.duringstopMeterNo
                = response.initialhyojiInfo.regInfoArea.shishinInputCont.preMeterNo;
            }
            // レスポンスを設定
            this.initResponse = response;
            // メッセージを表示
            this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
          }
        }, error => {
        });
  }

  /**
   * 登録処理
   * @private
   * @param {string} button ボタン名
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  private register(button: string): void {

    // 登録区分
    this.getControl('regDiv').setValue(button == 'register' ? '1' : '2');
    if (this.getControl('supplystopHms').value == '') {
      // 時刻が空の場合、nullに変換
      this.getControl('supplystopHms').setValue(null);
    }

    // Formの内容をリクエストに設定
    let rawValue = this.requestFormGroup.getRawValue();
    // 停止作業日時（変更後）は不要のため削除
    delete rawValue.supplystopResultInfo.workTimeAf;
    let request: Sgke342aRequest = rawValue;

    if (button == 'register'){
      if(this.getControl('workPlaceCode').value == Sgke340dComponent.WORK_PLACE_CODE_REMOTE) {
        // 登録 かつ 作業場所が遠隔の場合、画面に表示されていない入力項目はnullを設定
        request.supplystopResultInfo = {
          ...request.supplystopResultInfo,
          // マイコン点滅フラグ
          microcontrollermeterFlashingFlg: null,
          // メーター休止フラグ
          meterPauseFlg: null,
          // メーターガス栓閉止
          meterGasheisenstopFlg: null,
          // 閉止不能理由コード
          shutoffFunoRsncod: null,
          // 供給停止時処置フラグ（封印措置／ロック措置）
          supplysuspensiontimeTreatmentFlg: null,
          // エフ取付フラグ
          efuInstallationFlg: null,
          // 供給停止書投函場所コード
          supplystopdocumentPostingLocationcode: null,
          // 供給再開種別
          supplyresumptionClsfy: null,
        };
      }
      // 供給地点情報
      const suppntInfo = this.initResponse.initialhyojiInfo.basicInfoArea.suppntInfo;
      // 登録ボタン押下時は、メーター工事要否コードにレスポンスの値を設定
      request.supplystopResultInfo.meterConstYhicode = suppntInfo.meterConstYhicode;
    } else {
      // 中断ボタン押下時は、メーター工事要否コードにnullを設定
      request.supplystopResultInfo.meterConstYhicode = null;
    }

    // 供給停止時刻
    const supplystopHms = request.supplystopResultInfo.supplystopHms;
    request.supplystopResultInfo = {
      ...request.supplystopResultInfo,
      // 供給停止時刻を「HHｍｍ」形式に変換
      supplystopHms: supplystopHms ? supplystopHms.replace(/^(\d{2}):(\d{2}).*$/, '$1$2') : null
    };

    if (button == 'register') {
      //SGKE342A_供給停止結果登録一時保存・登録API呼び出し
      this.registrationService.doSgke342a(request)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          response => {
            // 担当作業一覧に戻る
            this.router.navigate(['sgke/sgke330d/'], {
              state: {
                errors: response?.responseCommon?.errors
              }
            });
          }, error => {
          });
      } else if (button == 'cancel') {
        //SGKE343A_供給停止結果中断API(SGKE342A)呼び出し
        this.pauseService.doSgke343a(request)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            response => {
              // 担当作業一覧に戻る
              this.router.navigate(['sgke/sgke330d/'], {
                state: {
                  errors: response?.responseCommon?.errors
                }
              });
            }, error => {
            });
      }

  }

  /**
   * 相関チェック
   * @private
   * @returns {boolean}
   * @memberof Sgke340dComponent
   */
  private checkCorrelation(): boolean {
    // 供給地点情報
    const suppntInfo = this.initResponse.initialhyojiInfo.basicInfoArea.suppntInfo;

    // マイコンメーター取得
    const meterBunruiCode = suppntInfo.meterBunruiCode;
    // 供給停止時処置フラグ（封印措置／ロック措置チェック）取得
    const supplysuspensiontimeTreatmentFlg = this.getControl('supplysuspensiontimeTreatmentFlg').value;
    // メーター休止取得
    const meterPauseFlg = this.getControl('meterPauseFlg').value;
    // メーターガス栓閉止取得
    const meterGasheisenstopFlg = this.getControl('meterGasheisenstopFlg').value;
    // 作業場所コード取得
    const workPlaceCode = this.getControl('workPlaceCode').value

    if (meterBunruiCode != Sgke340dComponent.METER_BUNRUI_CODE_MCU && supplysuspensiontimeTreatmentFlg != '1') {
      // マイコンメーター以外のメーター かつ 封印措置／ロック措置チェックが入っていない
      return true;
    }

    if (meterBunruiCode == Sgke340dComponent.METER_BUNRUI_CODE_MCU &&
      meterPauseFlg != '1' && meterGasheisenstopFlg != '1' && supplysuspensiontimeTreatmentFlg != '1') {
      // メータがマイコンメータ かつ
      // メータ休止チェックが入っていない かつ
      // メータガス栓閉止チェックが入っていない かつ
      // 封印措置／ロック措置チェックが入っていない
      return true;

    }

    return false;
  }

  /**
   * 延期登録処理
   * @private
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  private reschedule(): void {

    const supplystopResultCont = this.initResponse.initialhyojiInfo.regInfoArea.supplystopResultCont;

    // Formの内容をリクエストに設定
    let request: Sgke902aRequest = {
      requestCommon: null,
      supplystopresumptionResultInfo: {
        callmotoFuncDiv: '1',
        suppntSpno: this.getControl('suppntSpno').value,
        supplystopresumptionRrkno: this.getControl('supplystopresumptionRrkno').value,
        updateSrno: this.initResponse.initialhyojiInfo.supplystopresumptionPointinfomngUpdatesequencenumber,
        userName: this.getControl('userName').value,
        visitName: this.getControl('visitName').value,
        workPlaceCode: this.getControl('workPlaceCode').value,
        supplystopResultDivcd: this.getControl('supplystopResultDivcd').value,
        supplyresumptionResultDivcd: null,
        workTimeBf: supplystopResultCont.bfSupplystopPlndate,
        workTimeAf: this.getControl('workTimeAf').value,
        workTimezone: null,
      },
      supplyresumptionResultregistrationConsumptiondeviceinfoList: [
        {
          consumptiondeviceNo: null,
          setsubiNo: null,
          consumptiondeviceModel: null,
          consumptiondeviceModelname: null,
          manufactureYm: null,
          ventilationHoshiki: null,
          ventilationHoshikiMei: null,
          cnnctJokyo: null,
          cnnctJokyoMei: null,
          saleKeitai: null,
          saleKeitaiMei: null,
          manufacturer: null,
          manufacturerMei: null,
          model: null,
          installationPlace: null,
          installationlocationMei: null,
          nonconformityCode: null,
          nonconformityCont: null,
          covalue: null,
          covalueMei: null,
        }
      ]

    };

    //SGKE902A_供給停止・再開延期登録API呼び出し
    this.rescheduleService.doSgke902a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          // 担当作業一覧に戻る
          this.router.navigate(['sgke/sgke330d/'], {
            state: {
              errors: response?.responseCommon?.errors
            }
          });
        }, error => {
        });
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  private clearErrorMsg(): void {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
   * モーダル表示非表示イベント時処理
   * @param {boolean} isDisplay
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  private onModalIsDisplay(isDisplay: boolean): void {
    // エラーメッセージ表示エリア表示非表示を切替
    this.isErrorMessageDisplay = isDisplay;
  };

  /**
   * 受付基盤への画面遷移
   * @param {string} launchSourceScreen
   * @returns {void}
   * @memberof Sgke340dComponent
   */
  private navigateToReceptionPlatform(launchSourceScreen: string): void {

    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;

    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // 初期表示APIレスポンス．請求先情報取得
    const clmtoInfo = this.initResponse.initialhyojiInfo.basicInfoArea.clmtoInfo;

    // お客さま番号
    let customerNo: string = clmtoInfo.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = clmtoInfo.payCtrNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = launchSourceScreen;

    // anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く	
    window.open(`${url}${params}`, '_blank');

  }

}
